module.exports = __webpack_public_path__ + "img/unknown.0f504fdb.png";